<template>
	<button
		class="inline-flex flex-shrink-0 items-center justify-center gap-x-3 rounded-lg px-6 py-1 font-bold text-white text-base md:text-lg leading-none whitespace-nowrap transition-all ease-out duration-200"
		:class="styled"
		:type="type"
		:disabled="disabled"
		:loading="loading"
		@click="emit('onClick')"
	>
		<slot>
			<span class="button__text" v-html="text"></span>
			<slot name="icon">
				<template v-if="icon">
					<Icon :class="icon_class" class="w-5 h-5 button__icon flex-shrink-0" :icon="icon" />
				</template>
			</slot>
		</slot>

		<template v-if="loading">
			<span class="button__loading text-xs flex items-center" role="status">
				<Icon
					icon="line-md:loading-twotone-loop"
					class="w-8 h-8 animate-spin mr-2"
					aria-hidden="true"
				/>
				Carregando...
			</span>
		</template>
	</button>
</template>

<script lang="ts" setup>
import { Icon } from "@iconify/vue";

const props = defineProps({
	text: {
		type: String,
		default: () => "",
	},
	type: {
		type: String,
		default: () => "submit",
	} as any,
	color: {
		type: String,
		default: () => "primary",
	},
	icon_class: {
		type: String,
		default: () => "",
	},
	icon: {
		type: String,
		default: () => "",
	},
	disabled: {
		type: Boolean,
		default: () => false,
	},
	loading: {
		type: Boolean,
		default: () => false,
	},
	css: {
		type: String,
		default: () => "",
	},
});
const styled = computed(() => {
	return `button button--${props.color} bg-${props.color} ${props.css} ${!!props.loading ? "button--is-loading" : ""} ${!!props.disabled ? "button--is-disabled" : ""}`;
});

const emit = defineEmits(["onClick"]);
</script>

<style scoped>
.button:not(.button--is-disabled):not(.button--is-loading):hover {
	@apply brightness-[1.15] saturate-[1.25];
}

.button:not(.button--is-disabled):not(.button--is-loading):active {
	@apply brightness-[0.9];
}

.button.button--cta {
	@apply text-primary ;
}

.button.button--white {
	@apply text-primary;
}

.button.button--is-disabled {
	@apply cursor-not-allowed;
	background: #ededed;
    color: rgb(105 105 105);
    --tw-border-opacity: 1;
    border-color: rgb(105 105 105 / var(--tw-border-opacity));
}

.button.button--is-loading {
	@apply pointer-events-none cursor-default !justify-center !items-center !flex;
}
.button.button--is-loading .button__loading {
	@apply absolute m-auto z-10;
}

.button.button--is-loading > *:not(.button__loading) {
	@apply opacity-0;
}
</style>
